import { DASHBOARD_URLS, SEARCH_PARAMS_KEYS } from '.';

export const PAGE_URLS = {
  forgotPassword: '/onboarding/forgot-password',
  resetPassword: '/onboarding/reset-password',
  passwordChanged: '/onboarding/password-changed?type=#{type}',
  logIn: '/onboarding/log-in',
  onBoardinSignin: '/onboarding/log-in',
  dashboard: '/dashboard',
  addEmail: '/onboarding/add-email',
  otp: '/onboarding/otp?email=#{email}',
  addCompanyDetails: '/onboarding/company-details',
  aboutYourself: '/onboarding/about-yourself',
  contactDetails: '/verification/contact-details',
  home: '/dashboard/home',
  bulkApplication: '/verification/bulk-application',
  selectPackageDetails: '/verification/select-package-details',
  setPassword: `/onboarding/set-password?${SEARCH_PARAMS_KEYS.setPasswordType}=#{setPasswordType}`
};

export const NON_LOGGED_IN_PAGE_URLS = [
  PAGE_URLS.onBoardinSignin,
  PAGE_URLS.resetPassword,
  PAGE_URLS.forgotPassword,
  PAGE_URLS.passwordChanged.split('?')[0],
  PAGE_URLS.setPassword.split('?')[0],
  PAGE_URLS.addEmail,
  PAGE_URLS.otp.split('?')[0]
];

export const PARTNER_NOT_CREATED_PAGE_URLS = [
  PAGE_URLS.setPassword?.split('?')?.[0],
  PAGE_URLS.aboutYourself,
  PAGE_URLS.addCompanyDetails,
  DASHBOARD_URLS.approvalPending
];
